// core/react/ui.jsx — small UI kit shared by the apps: icons, sheets,
// toasts and segmented buttons. QR codes and the scanner are in ../../peerlink.
import React, { useEffect, useState, useSyncExternalStore } from 'react'

/* ===== Icons ===== */
const ICON = {
  play: '<path d="M8 5.5v13l10.5-6.5z" fill="currentColor" stroke="none"/>',
  pause: '<rect x="6.5" y="5" width="4" height="14" rx="1" fill="currentColor" stroke="none"/><rect x="13.5" y="5" width="4" height="14" rx="1" fill="currentColor" stroke="none"/>',
  back: '<path d="M11 7l-5 5 5 5M18 7l-5 5 5 5"/>',
  fwd: '<path d="M13 7l5 5-5 5M6 7l5 5-5 5"/>',
  restart: '<path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4.5h4.5"/>',
  mirror: '<path d="M12 3v18"/><path d="M9 7 4 12l5 5z"/><path d="M15 7l5 5-5 5z"/>',
  edit: '<path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/>',
  full: '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>',
  close: '<path d="M6 6l12 12M18 6 6 18"/>',
  minus: '<path d="M5 12h14"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  remote: '<rect x="7" y="3" width="10" height="18" rx="2"/><path d="M11 17.5h2"/>',
  camera: '<rect x="3" y="6" width="13" height="12" rx="2"/><path d="M16 10.5 21 8v8l-5-2.5"/>',
  mic: '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21"/>',
  sliders: '<path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>',
  file: '<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5M12 18v-6M9.5 14.5 12 12l2.5 2.5"/>',
  clicker: '<rect x="8" y="2.5" width="8" height="19" rx="4"/><path d="M12 6.5v2M10.5 13h3"/>',
  qr: '<path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4z"/><path d="M14 14h2v2h-2zM18 18h2v2h-2zM14 18h2M18 14h2"/>',
  lock: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
  wifi: '<path d="M2.5 9a14 14 0 0 1 19 0M5.5 12.5a9.5 9.5 0 0 1 13 0M8.8 16a5 5 0 0 1 6.4 0"/><circle cx="12" cy="19.5" r="1" fill="currentColor"/>',
  monitor: '<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M8 20h8M12 16v4"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  list: '<path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01"/>',
  user: '<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>',
  share: '<path d="M12 15V3M7.5 7.5 12 3l4.5 4.5"/><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/>',
  download: '<path d="M12 3v12M7.5 10.5 12 15l4.5-4.5"/><path d="M5 19h14"/>',
  record: '<circle cx="12" cy="12" r="7" fill="currentColor" stroke="none"/>',
  stop: '<rect x="6.5" y="6.5" width="11" height="11" rx="2" fill="currentColor" stroke="none"/>',
  scissors: '<circle cx="6" cy="6" r="2.5"/><circle cx="6" cy="18" r="2.5"/><path d="M8 7.5 20 17M8 16.5 20 7"/>',
  popout: '<rect x="3" y="5" width="18" height="14" rx="2"/><rect x="12" y="11" width="7" height="6" rx="1" fill="currentColor" stroke="none"/>',
  book: '<path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z"/><path d="M4 19V5M8 7h7"/>',
  check: '<path d="M5 12.5 10 17l9-10"/>',
  gamepad: '<path d="M7 8h10a4 4 0 0 1 3.9 4.8l-.8 3.7a2.2 2.2 0 0 1-3.9.9L14.5 15h-5l-1.7 2.4a2.2 2.2 0 0 1-3.9-.9l-.8-3.7A4 4 0 0 1 7 8z"/><path d="M8 11v3M6.5 12.5h3M15.5 12h.01M17.5 13.5h.01"/>',
  help: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.3a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2-2.4 3.6M12 17h.01"/>',
  captions: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M7 12h4M13 12h4M7 15.5h7"/>',
  switch: '<path d="M4 8h13l-3-3M20 16H7l3 3"/>',
  trash: '<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/>',
}
export function Icon({ name, className }) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" className={className} dangerouslySetInnerHTML={{ __html: ICON[name] || '' }} />
}

/* ===== Toasts ===== */
let toastState = { msg: '', id: 0, shown: false }
const toastSubs = new Set()
let toastT = 0
export function toast(msg) {
  clearTimeout(toastT)
  toastState = { msg, id: toastState.id + 1, shown: true }
  toastSubs.forEach((f) => f())
  toastT = setTimeout(() => { toastState = { ...toastState, shown: false }; toastSubs.forEach((f) => f()) }, 2600)
}
export function Toaster() {
  const s = useSyncExternalStore((f) => { toastSubs.add(f); return () => toastSubs.delete(f) }, () => toastState)
  return <div id="toast" role="status" aria-live="polite" style={{ opacity: s.shown ? 1 : 0 }} hidden={!s.msg}>{s.msg}</div>
}

/* ===== Sheets ===== */
const SHEET_OUT_MS = 160
const reducedMotion = () => typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
export function Sheet({ open, onClose, title, children, docked = false, wide = false, id }) {
  // Stays on screen for a short fade after closing, so sheets leave as smoothly as they arrive.
  const [shown, setShown] = useState(open)
  const [leaving, setLeaving] = useState(false)
  useEffect(() => {
    if (open) { setShown(true); setLeaving(false); return undefined }
    if (!shown) return undefined
    if (reducedMotion()) { setShown(false); return undefined }
    setLeaving(true)
    const t = setTimeout(() => { setShown(false); setLeaving(false) }, SHEET_OUT_MS)
    return () => clearTimeout(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])
  useEffect(() => {
    if (!open) return undefined
    const onKey = (e) => { if (e.key === 'Escape') onClose?.() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])
  if (!open && !shown) return null
  return (
    <div className={`overlay${docked ? ' docked' : ''}${leaving && !open ? ' leaving' : ''}`} id={id} aria-hidden={!open || undefined} onMouseDown={(e) => { if (open && !docked && e.target === e.currentTarget) onClose?.() }}>
      <div className={`sheet${wide ? ' wide' : ''}`} role="dialog" aria-modal={!docked} aria-label={title}>
        <div className="sheet-head">
          <h3>{title}</h3>
          <button className="icon-btn" type="button" aria-label="Close" onClick={onClose}><Icon name="close" /></button>
        </div>
        {children}
      </div>
    </div>
  )
}

/* ===== Segmented buttons ===== */
export function Seg({ value, options, onChange, label }) {
  return (
    <div className="seg" role="group" aria-label={label}>
      {options.map(([v, text]) => (
        <button key={String(v)} type="button" aria-pressed={String(v) === String(value)} onClick={() => onChange(v)}>{text}</button>
      ))}
    </div>
  )
}

/** Copy to clipboard with a toast either way. */
export async function copyText(text, okMsg = 'Copied') {
  try { await navigator.clipboard.writeText(text); toast(okMsg); return true }
  catch (e) { toast('Couldn’t copy here. Select the text and copy it by hand.'); return false }
}
